import { INVITAIONS_REQUEST, INVITAIONS_SUCCESS, INVITAIONS_FAIL } from "../constants/AuthConstant"

const initialState = {
  loading: false,
  action: "Invitations Action",
  result: null,
  msg: "",
  error: "",
};

const InvitationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case INVITAIONS_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case INVITAIONS_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case INVITAIONS_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default InvitationsReducer;
